














































































import Vue, { PropType } from "vue";

import CustomInputJson from "../../shared/CustomInputJson";
import { CustomInputCategory, CustomInputCategoryNames } from "../../shared/CustomInputCategory";
import { CustomInputType, CustomInputTypeNames } from "../../shared/CustomInputType";

export default Vue.extend({
  name: "FormCustomInput",
  components: {},
  props: {
    data: Object as PropType<CustomInputJson>,
    hideInputs: {
      type: Array,
      default() {
        return [];
      },
    },
    editable: Boolean,
    customId: {
      default: "0",
    },
    validation: Object,
    submitValidation: Boolean,
  },
  data() {
    return {
      CustomInputCategory: CustomInputCategory,
      CustomInputCategoryNames: CustomInputCategoryNames,
      CustomInputTypeNames: CustomInputTypeNames,
      CustomInputType: CustomInputType,
      details: null as CustomInputJson | null,
      toValidate: {} as any,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.details = this.data;
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      this.$emit("validateInput", "customInputs-" + this.customId, key);

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    setValueByCategory() {
      if (this.details != null) {
        if (this.details.type == CustomInputType.text) {
          this.details.value = "";
        } else {
          this.details.value = false;
        }
      }
    },

    checkHideInput(inputs: string[]): boolean {
      const vue = this;

      function isKeyOfContact(key: PropertyKey): key is keyof CustomInputJson {
        let keys: CustomInputJson = vue.details as CustomInputJson;
        return key in keys;
      }

      if (!inputs.some((i) => !this.hideInputs.includes(i))) {
        return true;
      }

      if (this.editable) {
        return false;
      }

      if (!inputs.some((i) => this.details && isKeyOfContact(i))) {
        return false;
      }

      if (!inputs.some((i) => this.details && isKeyOfContact(i) && this.details[i] != null)) {
        return true;
      }

      if (!inputs.some((i) => this.details && isKeyOfContact(i) && this.details[i] != "")) {
        return true;
      }

      return false;
    },
  },
  watch: {
    data() {
      this.details = this.data;
    },

    details: {
      handler(val, oldVal) {
        this.$emit("change", this.details);
      },
      deep: true,
    },
  },
  computed: {},
});
